import { render, staticRenderFns } from "./BetgameEditSortmode.vue?vue&type=template&id=50be3d26&scoped=true"
import script from "./BetgameEditSortmode.vue?vue&type=script&lang=js"
export * from "./BetgameEditSortmode.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditSortmode.vue?vue&type=style&index=0&id=50be3d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be3d26",
  null
  
)

export default component.exports